import { Route, Switch } from 'wouter';
import { Toaster } from 'sonner';

// Marketing/Public Pages
import PixCaptureHome from './pages/pixcapture-home';
import PixCaptureAbout from './pages/pixcapture-about';
import PixCaptureHelp from './pages/pixcapture-help';
import PixCaptureExpertCall from './pages/pixcapture-expert-call';
import PixCaptureAGB from './pages/pixcapture-agb';
import PixCaptureDatenschutz from './pages/pixcapture-datenschutz';
import PixCaptureImpressum from './pages/pixcapture-impressum';

// App Pages
import AppIndex from './pages/app-index';
import AppLogin from './pages/app-login';
import AppVerifyUser from './pages/app-verify-user';
import AppCamera from './pages/app-camera';
import AppCameraLandscapeDemo from './pages/app-camera-landscape-demo';
import AppUpload from './pages/app-upload';
import AppGallery from './pages/app-gallery';
import AppJobs from './pages/app-jobs';
import AppJobNew from './pages/app-job-new';
import AppSettings from './pages/app-settings';
import AppNotifications from './pages/app-notifications';
import AppNav from './pages/app-nav';
import AppSplash from './pages/app-splash';
import AppSplashFirstLaunch from './pages/app-splash-firstlaunch';

export default function App() {
  return (
    <>
      <Switch>
        {/* Marketing/Public Routes */}
        <Route path="/" component={PixCaptureHome} />
        <Route path="/about" component={PixCaptureAbout} />
        <Route path="/help" component={PixCaptureHelp} />
        <Route path="/expert-call" component={PixCaptureExpertCall} />
        <Route path="/agb" component={PixCaptureAGB} />
        <Route path="/datenschutz" component={PixCaptureDatenschutz} />
        <Route path="/impressum" component={PixCaptureImpressum} />

        {/* App Routes */}
        <Route path="/app" component={AppIndex} />
        <Route path="/app/login" component={AppLogin} />
        <Route path="/app/verify" component={AppVerifyUser} />
        <Route path="/app/camera" component={AppCamera} />
        <Route path="/app/camera/landscape" component={AppCameraLandscapeDemo} />
        <Route path="/app/upload" component={AppUpload} />
        <Route path="/app/gallery" component={AppGallery} />
        <Route path="/app/jobs" component={AppJobs} />
        <Route path="/app/jobs/new" component={AppJobNew} />
        <Route path="/app/settings" component={AppSettings} />
        <Route path="/app/notifications" component={AppNotifications} />
        <Route path="/app/nav" component={AppNav} />
        <Route path="/app/splash" component={AppSplash} />
        <Route path="/app/splash/first" component={AppSplashFirstLaunch} />

        {/* 404 Fallback */}
        <Route>
          <div className="min-h-screen flex items-center justify-center bg-[var(--color-white)]">
            <div className="text-center">
              <h1 className="text-[var(--color-black)] mb-4">404 - Seite nicht gefunden</h1>
              <a href="/" className="text-[var(--color-primary)] hover:underline">
                Zurück zur Startseite
              </a>
            </div>
          </div>
        </Route>
      </Switch>

      <Toaster position="top-center" />
    </>
  );
}
